{
	"all": "Todos",
	"emptyMessage": "Nenhum produto encontrado",
	"product": "Produto",
	"sku": "SKU",
	"price": "Preço",
	"mountable": "Montável"
}
